<template>
    <v-speed-dial
        v-model="isShow"
        fixed
        top
        right
        direction="bottom"
        :open-on-hover="false"
        transition="slide-y-transition"
        :close-on-content-click="false"
        ref="speedDial"
    >
      <template v-slot:activator>
        <v-btn v-model="isShow" color="primary" dark fab>
          <v-icon v-if="isShow">mdi-close</v-icon>
          <v-icon v-else>mdi-book-edit-outline</v-icon>
        </v-btn>
      </template>

        <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" :loading="loading" fab dark small color="red"
                       @click="onAction('addPage')">
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </template>
            <span>Добавить страницу</span>
        </v-tooltip>

        <template v-if="hasPage">
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on"
                           :loading="loading" fab dark small color="grey"
                           @click.stop="onAction('removePage')">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
                <span>Удалить текущую страницу</span>
            </v-tooltip>
        </template>

        <template v-if="hasPage">
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on"
                           :loading="loading" fab dark small color="green" @click.stop>
                        <v-file-input
                            accept="image/png, image/jpeg, image/svg"
                            hide-input
                            dense
                            prepend-icon="mdi-image-edit"
                            @change="onAction('setBackground', $event)"
                            class="flex-grow-0"
                        ></v-file-input>
                    </v-btn>
                </template>
                <span>Фоновое изображение текущей страницы</span>
            </v-tooltip>
        </template>

        <template v-if="hasPage">
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on"
                           :loading="loading" fab dark small color="red" @click.stop="onAction('renderPdf')">
                        <v-icon>mdi-file-pdf-box</v-icon>
                    </v-btn>
                </template>
                <span>Печать PDF</span>
            </v-tooltip>
        </template>

        <template v-if="hasPage">
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on"
                           :loading="loading" fab dark small color="red"
                           @click.stop="onAction('saveDocument')">
                        <v-icon>mdi-content-save-move-outline</v-icon>
                    </v-btn>
                </template>
                <span>Сохранить документ</span>
            </v-tooltip>
        </template>

        <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on"
                       :loading="loading" ref="pagePropertiesButton" fab dark small color="blue"
                       @click.stop="onAction('showDocumentSettings')">
                    <v-icon>mdi-cog</v-icon>
                </v-btn>
            </template>
            <span>Параметры документа</span>
        </v-tooltip>

        <!-- <v-menu
          v-model="isShowPageProperties"
          :close-on-content-click="false"
          :close-on-click="false"
          :nudge-width="220"
          v-if="hasPage && !!$refs.pagePropertiesButton && !!$refs.pagePropertiesButton.$el"
          :attach="$refs.pagePropertiesButton.$el"
          content-class="page-properties-dialog"
        >
          <v-card @click.stop>
            <v-card-title>
              <span>Параметры страницы</span>
              <v-btn absolute right dark x-small color="indigo" @click="isShowPageProperties = false">
                <v-icon dark x-small>mdi-close</v-icon>
              </v-btn></v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-list>
                <v-list-item>
                  <v-list-item-title>Отступ слева</v-list-item-title>
                  <v-list-item-action>
                    <v-text-field
                      v-model="document.padding_left"
                      dense
                      hide-details
                      type="number"
                      suffix="mm"
                    ></v-text-field>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Отступ справа</v-list-item-title>
                  <v-list-item-action>
                    <v-text-field
                      v-model="document.padding_right"
                      dense
                      hide-details
                      type="number"
                      suffix="mm"
                    ></v-text-field>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Отступ сверху</v-list-item-title>
                  <v-list-item-action>
                    <v-text-field
                      v-model="document.padding_top"
                      dense
                      hide-details
                      type="number"
                      suffix="mm"
                    ></v-text-field>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Отступ снизу</v-list-item-title>
                  <v-list-item-action>
                    <v-text-field
                      v-model="document.padding_bottom"
                      dense
                      hide-details
                      type="number"
                      suffix="mm"
                    ></v-text-field>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-menu> -->
    </v-speed-dial>
</template>

<script>
export default {
  name: 'DocumentActions',
  props: {
    value: Boolean,
    hasPage: Boolean,
    document: {
      type: Object,
      default: () => ({}),
    },
    loading: Boolean,
  },
  data: () => ({
    //isShowPageProperties: false,
  }),
  computed: {
    isShow: {
      get() {
        return this.value;
      },
      set(v) {
        /* if (!v) {
          this.isShowPageProperties = false;
        } */
        this.$emit('input', v);
      },
    },
  },
  methods: {
    onAction(action, params) {
        this.$emit('action', {action, params});
    },
  },
}
</script>
<style lang="scss" scoped>
    .v-speed-dial--fixed, .v-speed-dial--absolute {
        z-index: 99991;
        top: 120px;
    }
    .v-speed-dial .v-input.v-input--dense {
        margin-top: 0;
    }
    .page-properties-dialog {
      left: auto!important;
      top: auto!important;
      right: 50px;
      bottom: 0;
      text-transform: none;
      font-size: 13px;
      .v-card {
        &__title {
          font-size: 1em;
          padding: 0 16px;
          background: #3f51b5;
          color: #fff;
          font-weight: bold;
          .v-btn {
            min-width: 16px;
            padding: 0;
            right: 0;
          }
        }
        &__text {
          font-size: 1em;
          padding: 4px 16px 10px;
        }
      }
      .v-list {
        padding: 0;
        .v-list-item {
          padding: 1px 0;
          min-height: 32px;
          &__title {
            font-size: 1em;
            text-align: left;
          }
          &__action {
            margin: 0 0 0 8px;
            &:last-of-type:not(:only-child) {
              margin-left: 8px;
            }
          }
          .v-input {
            font-size: 1em;
            text-align: right;
            input {
              text-align: right;
              padding: 0;
              text-indent: 10px;
              direction: rtl;
            }
          }
        }
      }
    }
</style>
<style scoped>
  .v-speed-dial .v-input >>> .v-input__prepend-outer {
    margin-right: 0;
    flex: 1;
  }
</style>
